var render = function render(){var _vm=this,_c=_vm._self._c;return _c('guest-overage-confirmation',{attrs:{"group-path":_vm.group.path,"member":_vm.member,"role":_vm.role},on:{"busy":_vm.emitBusy,"confirm":_vm.saveRole,"cancel":_vm.emitReset},scopedSlots:_vm._u([{key:"default",fn:function({ checkOverage }){return [_vm._t("default",null,{"saveRole":checkOverage})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }